<template>
    <div>
        <div class="cart__promo">
            <input v-model="oid" class="cart__promo-input" id="promo" name="promo" type="text" placeholder="Введите номер заказа"/>
            <button type="button" v-on:click="findOrder()" class="btn btn--blue cart__promo-btn">Загрузка заказа</button>
        </div>

        <div class="cart__promo" v-if="isOrderFound">
            <button type="button" v-on:click="loadOrder()" class="btn btn--blue cart__promo-btn">Загрузить в корзину</button>
        </div>

        <div v-html="this.message"></div>
    </div>
</template>

<script>
    export default {
        name: "cart-search-order",
        data () {
            return {
                isOrderFound:false,
                oid:'',
                message:''
            }
        },
        methods: {
            findOrder() {
                this.$store.commit('setLoading', true)
                let params = new URLSearchParams();
                params.append('action', 'find_order')
                params.append('oid', this.oid);
                axios
                    .get('/rest/spec', {params})
                    .then((response) => {
                        const data = JSON.parse(response.data)
                        if(data.error==='') {
                            this.isOrderFound = true;
                            this.message = 'найден заказ ' + data.id + ' ' + data.name + ' ' + data.email;
                        } else {
                            this.message = data.error;
                        }
                        this.$store.commit('setLoading', false)
                    }).catch(error => {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error.message)
                        throw error
                })
            },
            loadOrder() {
                this.$store.commit('setLoading', true)
                let params = new URLSearchParams();
                params.append('action', 'load_order')
                params.append('oid', this.oid);
                axios
                    .post('/rest/spec', params)
                    .then((response) => {
                        this.$store.dispatch('setCartItems')
                        this.$store.commit('setLoading', false)

                        location.href='/cart'

                    }).catch(error => {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error.message)
                        throw error
                    })
            }
        }
    }
</script>

<style scoped>

</style>
